import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_EXPIRED_AUTH_REQUEST: '',
  GET_EXPIRED_AUTH_SUCCESS: '',
  GET_EXPIRED_AUTH_FAILURE: '',

};

types = setStoreTypeValues(types, 'authExpired');

export default types;
